import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  ViewEncapsulation,
} from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TextInputComponent implements OnInit {
  @Input() icon = '';
  @Input() type = 'text';
  @Input() inputFormControl: AbstractControl;
  @Input() placeholder = '';
  @Input() isDisabled = false;
  @Input() errorOnSubmit = false;
  @Input() errorMessage = '';
  @Input() maxLength: number;
  @Input() autocomplete = 'auto';
  @Input() styling = '';
  @Output() focusChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() enterPressed = new EventEmitter<KeyboardEvent>();

  @ViewChild('inputControl', { static: false }) private inputElement: ElementRef<HTMLInputElement>;

  private isFocused = false;
  private isErrorOnSubmit = false;

  private containerErrorClass = 'text-input-container-error';
  private containerDisabledClass = 'text-input-container-disabled';
  private containerFocusedClass = 'text-input-container-focused';
  private iconErrorClass = 'text-input-icon-error';
  private iconFocusedClass = 'text-input-icon-focused';

  constructor() {}

  ngOnInit() {
    this.isErrorOnSubmit = this.errorOnSubmit;
  }

  public focus = () => {
    this.inputElement.nativeElement.focus();
    this.inputElement.nativeElement.selectionStart = 0;
    this.inputElement.nativeElement.selectionEnd = this.inputElement.nativeElement.value.length;
  };

  public onlyFocus = () => {
    this.inputElement.nativeElement.focus();
  };

  public onFocus = (isFocused: boolean) => {
    this.isFocused = isFocused;
    this.focusChange.emit(true);
  };

  public getContainerClass = (): string => {
    if (this.isDisabled && this.hasError()) {
      return this.containerDisabledClass + ' ' + this.containerErrorClass;
    }
    if (this.isDisabled) {
      return this.containerDisabledClass;
    }
    if (this.hasError()) {
      return this.containerErrorClass;
    }
    if (this.isFocused) {
      return this.containerFocusedClass;
    }
    return '';
  };

  public getIconClass = (): string => {
    if (this.hasError()) {
      return this.iconErrorClass;
    }
    if (this.isFocused) {
      return this.iconFocusedClass;
    }
    return '';
  };

  public hasError = () =>
    !this.errorOnSubmit && this.inputFormControl?.invalid && (this.isErrorOnSubmit || this.inputFormControl.touched);

  public hasErrorText = () => this.hasError() && this.errorMessage && this.errorMessage.length > 0;

  public onEnter = (event: KeyboardEvent) => {
    this.enterPressed.emit(event);
  };

  public value = '';
}
